import React, { useState, useEffect } from 'react';
import AccountDeletionModal from '../../../components/account/AccountDeletionModal';

const AccountSection = ({ handleLogoutClick, user }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user can delete organization (is owner/admin)
  useEffect(() => {
    const fetchUserPermissions = async () => {
      try {
        setIsLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8081';
        const response = await fetch(`${apiUrl}/api/account-deletion/user/organizations-deletion-permissions`, {
          credentials: 'include'
        });
        if (response.ok) {
          const data = await response.json();
          
          if (data.organizations && data.organizations.length > 0) {
            const org = data.organizations[0]; // Assuming user is in one organization
            setUserRole(org.userRole);
            setOrganizationId(org.organizationId);
            setOrganizationName(org.organizationName);
          } else {
            // Set default role if no organizations
            setUserRole('member');
          }
        } else {
          console.error('API response not ok:', response.status, response.statusText);
          setUserRole('member');
        }
      } catch (error) {
        console.error('Failed to fetch user permissions:', error);
        // Set default role on error
        setUserRole('member');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserPermissions();
  }, []);

  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true);
  };

  const getDeleteButtonText = () => {
    if (isLoading) {
      return 'Loading...';
    }
    if (userRole === 'owner' || userRole === 'admin') {
      return 'Delete account';
    }
    return 'Contact administrator';
  };

  return (
    <>
      <div className="rounded-2xl border border-gray-200 dark:border-[#444444] mt-2 p-6">
        <h2 className="text-xl font-semibold mb-6">Settings</h2>
        
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span>Log out</span>
            <button
              onClick={handleLogoutClick}
              className="px-4 py-2 border bg-white dark:bg-[#181818] border-gray-300 dark:border-[#444444] rounded-[10px] hover:bg-gray-50 dark:hover:bg-[#181818]"
            >
              Log out
            </button>
          </div>
          
          <div className="flex justify-between items-center">
            <span>Delete account</span>
            <button
              onClick={handleDeleteClick}
              disabled={isLoading}
              className="px-4 py-2 border bg-white dark:bg-[#181818] border-gray-300 dark:border-[#444444] rounded-[10px] hover:bg-gray-50 dark:hover:bg-[#181818] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {getDeleteButtonText()}
            </button>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-[#444444] p-6 mt-6">
        <h2 className="text-xl font-semibold mb-6">Export data</h2>
        
        <div className="flex justify-between items-center">
          <span>Export data</span>
          <button className="px-4 py-2 bg-white dark:bg-[#181818] border dark:border-[#444444] border-gray-300 rounded-[10px] hover:bg-gray-50">
            Coming soon
          </button>
        </div>
      </div>

      {/* Account Deletion Modal */}
      <AccountDeletionModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        organizationId={organizationId}
        organizationName={organizationName}
        userRole={userRole}
      />
    </>
  );
};

export default AccountSection; 